module.exports = __webpack_public_path__ + "static/media/profile-picture.14fd76b1.jpg";